import { InsuranceList } from './InsuranceList';
import { InsuranceCreate } from './InsuranceCreate';
import { InsuranceEdit } from './InsuranceEdit';
import { InsuranceShow } from './InsuranceShow';

export default {
  list: InsuranceList,
  create: InsuranceCreate,
  edit: InsuranceEdit,
  show: InsuranceShow,
};
